import { render } from "./FileManagementMenu.vue?vue&type=template&id=44ecfe47&scoped=true"
import script from "./FileManagementMenu.vue?vue&type=script&lang=js"
export * from "./FileManagementMenu.vue?vue&type=script&lang=js"

import "./FileManagementMenu.vue?vue&type=style&index=0&id=44ecfe47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ecfe47"]])

export default __exports__